import React, { Component } from 'react'
import { connect } from 'react-redux'

import { setFavouriteImage } from '../../redux/album'
import Icon from '../Icon'
import { getFavouriteImages } from '../../utils/images'

class ImageFavouriteButton extends Component {
  render () {
    const { id, favouriteImages, setFavouriteImage, className } = this.props
    const favourited = favouriteImages && favouriteImages.indexOf(id) !== -1
    return (
      <button
        className={className}
        onClick={() => setFavouriteImage(id, !favourited)}>
        <Icon icon={favourited ? 'heart' : 'heart-outline'} />
      </button>
    )
  }
}

const mapStateToProps = (state) => ({
  favouriteImages: getFavouriteImages(state)
})

const mapDispatchToProps = {
  setFavouriteImage
}

export default connect(mapStateToProps, mapDispatchToProps)(ImageFavouriteButton)



// WEBPACK FOOTER //
// ./src/components/image/ImageFavouriteButton.js